// extracted by mini-css-extract-plugin
export default {"custom-colors-styles":"custom-colors-styles__IO4Q6"};